<template>
  <div>
      <div class="upload-image-preview">
          <v-img
            :aspect-ratio="16/9"
            :width="300"
            src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
            ></v-img>
            <v-btn icon><v-icon>mdi-heart</v-icon></v-btn>
      </div>
      <div>
          <v-file-input
            chips
            small-chips
            outlined
            dense
            v-model="organizationPhoto"
            prepend-icon="mdi-camera-enhance"
            :label="$page.props.lang.choose_photo || 'Choose Image'"
            @change="onFileChange"></v-file-input>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods: {
        onFileChange() {
            this.imageLoading = true;
            let file =  this.thumbnail;
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            let formData = new FormData();
            formData.append('file', file);

            axios.post('/backoffice/workout/upload', formData, config)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.imageLoading = false;
                        this.organizationPhotoUrl = response.data.main_logo_path; 
                    }
                })
                .catch(error => {
                    this.imageLoading = false

                    if(error) {
                        this.organizationPhoto = null;     
                    }
                })
        },
    }

}
</script>

<style>

</style>